<div class="profile-avatar">
  <img
    class="profile-avatar__avatar"
    [src]="profileAvatarUrl"
    (load)="onLoad()"
    (error)="onError()"
    [ngClass]="{
      'profile-avatar__avatar--loaded': isLoaded,
      'profile-avatar__avatar--hidden': !isLoaded,
      'profile-avatar__avatar--large' : size === 'large',
    'profile-avatar__avatar--small' : size === 'small',
    }"
    [class.loaded]="isLoaded"
    [class.hidden]="!isLoaded"
  />
  @if(!isLoaded) {
  <div
    style="height: 40px; width: 40px"
    [medSkeletonLoading]="true"
    class="profile-avatar__avatar"
  ></div>
  }
</div>
